import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export default function DeckCard({ title, description, onClick, selected, src }) {
    return (
        <Card
            sx={{
                maxWidth: 500,
                margin: 5,
                backgroundColor: selected ? "#e8e8ff" : "",
                transition: "background-color 0.3s",
            }}
        >
            <CardActionArea onClick={onClick}>
                <CardMedia
                    component="img"
                    sx={{
                        padding: "1em 1em 0 1em",
                        objectFit: "contain",
                        width: "350px", // Ensure the image doesn't exceed its container
                        margin: "0 auto", // Center the image horizontally
                    }}
                    height="250"
                    image={src}
                    alt="Deck"
                />
                <CardContent>
                    {selected && ( // Render the checkmark when 'selected' is true
                        <div
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                color: "green", // You can change the color
                            }}
                        >
                            ✓
                        </div>
                    )}
                    <Typography gutterBottom variant="h5" component="div">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
